import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withHandlers, withProps, withStateHandlers } from 'recompose'
import {
  openedMeetingEmailModal
} from 'app/modules/meetings/actions'
import {
  fetchAssistantAgentSettings,
  patchAssistantAgentSettings
} from 'app/modules/assistantSettings/actions'
import { assistantAgentSettings } from 'app/modules/assistantSettings/selectors'
import { hasProPlan } from 'app/modules/gates/selectors'
import {
  properties as userProperties
} from 'app/modules/user/properties/selectors'
import { fetchMeetingSettings, updateMeetingSettings } from 'app/modules/meetings/actions'
import { getMeetingSettings } from 'app/modules/meetings/selectors'
import MeetingEmailSettings from './component'

function mapStateToProps(state) {
  return {
    assistantAgentSettings: assistantAgentSettings(state),
    hasProPlan: hasProPlan(state),
    userProperties: userProperties(state),
    meetingSettings: getMeetingSettings(state),
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        fetchAssistantAgentSettings,
        patchAssistantAgentSettings,
        openedMeetingEmailModal,
        fetchMeetingSettings,
        updateMeetingSettings,
      },
      dispatch
    ),
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      this.props.actions.fetchAssistantAgentSettings()
      this.props.actions.fetchMeetingSettings()
    },
  }),
  withProps(({ assistantAgentSettings, userProperties }) => ({
    confirmationEmailStatus: assistantAgentSettings.getIn(['MEETING_CONFIRMATION', 'on'], false),
    confirmationDelayTime: assistantAgentSettings.getIn(['MEETING_CONFIRMATION', 'delayTime'], false),
    reminderEmailStatus: assistantAgentSettings.getIn(['MEETING_REMINDER', 'on'], false),
    reminderDelayTime: assistantAgentSettings.getIn(['MEETING_REMINDER', 'delayTime'], false),
    reminderFollowUpDelayTime: assistantAgentSettings.getIn(['MEETING_REMINDER_FOLLOW', 'delayTime'], false),
    seenPersonalizationEmailEducation: userProperties.get('HAS_SEEN_PERSONALIZE_MEETING_EMAILS_EDUCATION', false)
  })),
  withHandlers({
    toggleMeetingConfirmationStatus: ({ actions, assistantAgentSettings, confirmationEmailStatus }) => () => {
      const newSettings = assistantAgentSettings
        .setIn(['MEETING_CONFIRMATION', 'on'], !confirmationEmailStatus)
        .setIn(['MEETING_RESCHEDULE_CONFIRMATION', 'on'], !confirmationEmailStatus)
      return actions.patchAssistantAgentSettings({ settings: newSettings, meetingCopy: true })
    },
    toggleMeetingReminderStatus: ({ actions, assistantAgentSettings, reminderEmailStatus }) => () => {
      const newSettings = assistantAgentSettings
        .setIn(['MEETING_REMINDER', 'on'], !reminderEmailStatus)
        .setIn(['MEETING_REMINDER_FOLLOW', 'on'], !reminderEmailStatus)
      return actions.patchAssistantAgentSettings({ settings: newSettings, meetingCopy: true })
    },
    toggleMeetingManagement: ({ actions, meetingSettings }) => () => {
      const { allowMeetingManagement = false } = meetingSettings
      const settings = meetingSettings.set('allowMeetingManagement', !allowMeetingManagement)
      actions.updateMeetingSettings(settings)
    }
  }),
  withStateHandlers(
    { 
      confirmationModal: false,
      reminderModal: false,
      gatedModal: false
    },
    {
      toggleModal: () => (modalName, state) => ({ [modalName]: state }),
    }
  )
)(MeetingEmailSettings)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/MeetingEmailSettings/index.js